/**
 * AUTO GENERATED :: DO NOT EDIT DIRECTLY
 */

type Parameter = string | number;
export const Endpoints = {
  me: 'me',
  config: 'config',
  'sessions.create': 'login',
  'sessions.get-details': 'login/sso/login-response',
  'global-data': 'global-data',
  'config.timezones': 'config/timezones',
  'user.update': 'user',
  'glossary.show': 'glossary',
  'glossary.create': 'glossary',
  'team-glossary.list': 'team-glossary',
  'team-glossary.create': 'team-glossary',
  'team-glossary.update': 'team-glossary',
  'team-glossary.destroy': 'team-glossary/multiple',
  'team-glossary.show': 'team-glossary/{glossaryId}',
  'meta-glossary.show': 'meta-glossary',
  'meta-glossary.create': 'meta-glossary',
  'meta-glossary.update': 'meta-glossary',
  'meta-glossary.destroy': 'meta-glossary',
  'meta-glossary.search': 'meta-glossary',
  'meta-glossary.used-options': 'meta-glossary/used-options',
  'team.glossary.treatments': 'team/glossary/treatment-types',
  'team.glossary.treatment.update': 'team/glossary/treatment-types/{id}',
  'metadata.show': 'metadata-glossary/{id}',
  'metadata.options.show': 'metadata-glossary/{id}/options',
  'team.sso_providers': 'team/sso_providers/{type}',
  'team.studies.forms': 'team/studies/forms',
  'team.studies.forms.get': 'team/studies/forms/{formId}',
  'team.studies.forms.show': 'team/studies/forms/{id}',
  'team.studies.forms.showAll': 'team/studies/forms',
  'team.studies.forms.bulkDelete': 'team/studies/forms/multiple',
  'team.studies.forms.create': 'team/studies/forms',
  'team.studies.forms.update': 'team/studies/forms/{id}',
  'team.studies.forms.delete': 'team/studies/forms/{id}',
  'team.studies.forms.metadata': 'team/studies/forms/{id}/metadata-ids',
  'team.studies.forms.section.show': 'team/studies/forms/{formId}/sections/{sectionId}',
  'team.studies.forms.section.create': 'team/studies/forms/{formId}/sections',
  'team.studies.forms.section.update': 'team/studies/forms/{formId}/sections/{sectionId}',
  'team.studies.forms.section.delete': 'team/studies/forms/{formId}/sections/{sectionId}',
  'team.studies.groups': 'team/settings/group-metadata',
  'password_resets.create': 'password/email',
  'password_resets.update': 'password/reset',
  'password_resets.evaluate': 'password_resets/evaluate',
  'studies.create': 'studies',
  'studies.search': 'studies',
  'studies.base': 'studies/base',
  'studies.show.p': 'p/studies/{id}',
  'studies.metrics': 'studies/{id}/metrics',
  'studies.show': 'studies/{id}?include&#x3D;{include}',
  'studies.active': 'studies/active',
  'studies.archived': 'studies/archived',
  'studies.cancelled': 'studies/canceled',
  'studies.links': 'studies/{study_id}/links',
  'studies.links.delete': 'studies/{study_id}/links/{link_id}',
  'studies.links.update': 'studies/{study_id}/links/{link_id}?include&#x3D;{include}',
  'studies.links.create': 'studies/{study_id}/links?include&#x3D;{include}',
  'studies.links.create.bulk': 'studies/{study_id}/links/multiple?include&#x3D;{include}',
  'studies.samples.index': 'studies/{studyId}/samples',
  'study.types': 'study/types',
  'study.presets': 'study-presets',
  'studies.update': 'studies/{id}',
  'studies.destroy': 'studies/{id}',
  'studies.archive': 'studies/{id}/archive',
  'studies.unarchive': 'studies/{id}/unarchive',
  'studies.cancel': 'studies/{id}/cancel',
  'studies.uncancel': 'studies/{id}/uncancel',
  'studies.groups.metrics.list': 'studies/{studyId}/study-groups/metrics?{query}',
  'studies.groups.list': 'studies/{id}/study-groups',
  'studies.alerts.settings.list': 'studies/{studyId}/alerts',
  'studies.alerts.settings.create': 'studies/{studyId}/alerts',
  'studies.alerts.settings.update': 'studies/{studyId}/alerts/{alertId}',
  'studies.animal.alert.update': 'studies/{studyId}/animals/{animalId}/alerts/{alertId}',
  'studies.alerts.settings.bulk-delete': 'studies/{studyId}/alerts/multiple',
  'studies.groups.configure.treatments': 'studies/{studyId}/study-groups/configure-treatments',
  'studies.cages.create': 'cages/{studyId}',
  'studies.collections': 'cages',
  'studies.collections.show': 'studies/{studyId}/collections/{id}',
  'studies.collections.create': 'studies/{id}/collections',
  'studies.collections.animals': 'studies/{studyId}/collections/{id}/animals',
  'studies.cages.list': 'studies/{studyId}/cages',
  'studies.files': 'studies/{id}/files',
  'studies.files.update': 'studies/{id}/files',
  'studies.files.name': 'studies/{id}/files?name&#x3D;{name}',
  'drafts.files': 'drafts/{id}/files',
  'drafts.files.name': 'drafts/{id}/files?name&#x3D;{name}',
  'studies.export.create.email': 'studies/{id}/exports/email',
  'studies.export.create.download': 'studies/{id}/exports/download',
  'studies.export.audit-log': 'studies/{id}/audit/export',
  'studies.measurements.import-template': 'studies/{id}/measurements-import-template',
  'studies.groups.bulk': 'studies/{studyId}/study-groups/bulk',
  'studies.measurements.get': 'studies/{id}/measurements',
  'studies.measurements.create': 'studies/{id}/measurements',
  'studies.measurements.update': 'studies/{id}/measurements',
  'studies.observations.check': 'studies/{id}/check-observations',
  'studies.treatments': 'studies/{studyId}/treatments',
  'studies.treatment': 'studies/{studyId}/treatments/{treatmentId}',
  'studies.treatment.show': 'studies/{studyId}/treatments?{query}',
  'studies.treatment.delete': 'studies/{studyId}/treatments',
  'studies.animal.show': 'studies/{studyId}/animals/{id}',
  'studies.animal.alerts': 'studies/{studyId}/animals/{id}/alerts',
  'animals.update.bulk': 'animals',
  animal: 'animals/{id}',
  'animals.identifiers.bulk.update': 'animals/identifiers',
  'animals.tracking.date.bulk.update': 'animals/tracking-date',
  'animals.dob.bulk.update': 'animals/dob',
  'animals.sex.bulk.update': 'animals/sex',
  'animals.terminate': 'animals/terminate',
  'animals.update-terminate': 'animals/update-terminate',
  'animals.destroyMany': 'animals/{study}/multiple',
  'animals.destroyManyColony': 'animals/multiple',
  'animals.undo-terminate': 'animals/undo-terminate',
  'animals.dose.create': 'animals/{animalId}/dosages',
  'animals.update-termination': 'animals/update-termination',
  'studies.check-measurements': 'studies/{id}/check-measurements',
  'studies.observations.show': 'studies/{id}/observations',
  'studies.observations.types': 'studies/{id}/observation-types',
  'studies.observations.export': 'studies/{id}/observations/export',
  'studies.observations.filter.get': 'studies/{id}/observations/filter_options',
  'studies.approvals.list': 'studies/{id}/approvals',
  'studies.requests.list': 'studies/{id}/requests',
  'studies.requests.get': 'studies/{studyId}/requests/{requestId}?include&#x3D;{query}',
  'studies.requests.create': 'studies/{study}/requests',
  'studies.requests.update': 'requests/{requestId}',
  'studies.randomization.export': 'studies/{studyApiId}/randomizations/export',
  'requests.templates.list': 'requests/templates',
  'requests.templates.show': 'requests/templates/{requestTemplate}',
  'requests.templates.update': 'requests/templates/{requestTemplate}',
  'requests.templates.delete': 'requests/templates/{requestTemplate}',
  'requests.request.template.show': 'requests/templates/{requestId}',
  'requests.request.show': 'requests/{requestId}',
  'requests.request.samples': 'requests/{requestId}/samples?{query}',
  'requests.request.samples.add': 'requests/{requestId}/samples',
  'requests.request.samples.delete.bulk': 'requests/{requestId}/samples',
  'requests.comments': 'requests/{requestId}/comments',
  'approvals.templates.create': 'approvals/templates',
  'approvals.templates.list': 'approvals/templates{query}',
  'approvals.templates.list.all': 'approvals/templates?for_select&#x3D;1',
  'approvals.templates.show': 'approvals/templates/{approvalTemplate}',
  'approvals.templates.update': 'approvals/templates/{approvalTemplate}',
  'approvals.templates.delete': 'approvals/templates/{approvalTemplate}',
  'approvals.request.show': 'approvals/requests/{approvalRequestId}',
  'approvals.requests.update': 'approvals/requests/{approvalRequestId}',
  'approvals.requests.show.pending': 'approvals/requests?filters[]&#x3D;status|eq|pending&amp;filterType&#x3D;and&amp;',
  'approvals.requests.show.approved':
    'approvals/requests?filters[]&#x3D;status|ne|pending&amp;filterType&#x3D;and&amp;',
  'approvals.requests': 'approvals/requests/{approvalRequestId}?include&#x3D;{query}',
  'approvals.comments': 'approvals/{approvalId}/comments',
  'approvals.approvers.add': 'approvals/requests/{approvalRequestId}/approvers',
  'user.requests.list': 'user/requests',
  requests: 'requests/{requestId}?include&#x3D;{query}',
  'requests.update': 'requests/{requestId}',
  'users.list': 'users',
  'users.create': 'team/users',
  'users.update': 'users/{id}',
  'users.invitation': 'users/{id}/invitation',
  'users.revoke-invitation': 'users/{id}/revoke-invitation',
  'users.accept-invite': 'team/join/{invitation}',
  'collections.update': 'collections/{id}',
  'collections.destroy': 'collections/{id}',
  'observations.create': 'animals/{id}/observations',
  'observations.update': 'observations/{id}',
  'observations.destroy': 'observations/{id}',
  'animal.sample.create': 'animals/{id}/samples',
  'animal.sample.update': 'samples/{id}',
  'animal.sample.get': 'animals/{animalId}/samples/{sampleId}',
  'animal.latestMeasurement.get': 'studies/{studyId}/animals/{animalId}/latest-measurements/{measurement}',
  'samples.index': 'samples',
  'samples.update': 'samples/{id}',
  'samples.destroy': 'samples/{id}',
  'samples.export': 'export-samples',
  'samples.export.study': 'export-samples/{studyId}',
  'samples.sample-filters': 'sample-filters',
  'samples.validate.isNameUnique': 'samples/validate/unique-name',
  'samples.bulk.create': 'studies/{studyId}/samples/bulk',
  'tasks.templateGroups.create': 'tasks/template-groups',
  'tasks.templateGroups.show': 'tasks/template-groups',
  'tasks.templateGroups.show-item': 'tasks/template-groups/{id}',
  'tasks.templateGroups.delete': 'tasks/template-groups/{id}',
  'tasks.templateGroups.update': 'tasks/template-groups/{id}',
  'tasks.template.create': 'tasks/template-groups/{taskTemplateGroup}/templates',
  'tasks.template.update': 'tasks/templates/{id}',
  'tasks.template.destroy': 'tasks/templates/{id}',
  'tasks.show': 'tasks?date&#x3D;{date}',
  'tasks.update': 'tasks/tasks/{id}',
  'tasks.create': 'studies/{study}/tasks',
  'tasks.destroy': 'tasks/tasks/{id}',
  'tasks.pending': 'tasks/pending',
  'species.index': 'species?include&#x3D;{query}',
  species: 'species',
  'species.update': 'species/many',
  'animals.createMany': 'animals',
  'cages.show': 'cages',
  'cages.createMany': 'cages',
  'cages.updateMany': 'cages',
  'cages.destroyMany': 'cages/multiple',
  'cages.index': 'cages',
  'cages.destroy': 'cages/{id}',
  'cages.update': 'cages/{id}',
  'cage.index': 'cages/{id}?include&#x3D;{query}',
  'animals.updateMany': 'animals',
  'cages.filterOptions': 'cages/filter_options',
  'animals.filterOptions': 'animals/filter_options',
  'animals.show': 'animals',
  'animals.search': 'animals',
  'credentials.scopes.get': 'credentials/scopes',
  'teams.treatmentTypes.get': 'team/glossary/treatment-types?include&#x3D;{query}',
  'teams.treatmentTypes.post': 'team/glossary/treatment-types',
  'teams.treatmentTypes.validate': 'team/glossary/treatment-types/validate?name&#x3D;{treatmentName}',
  'teams.treatmentTypes.delete': 'team/glossary/treatment-types/{treatmentTypeId}',
  'treatment-units': 'treatment-units',
  'treatment.form': 'treatment-forms/{treatmentMethod}',
  'dosing.animals.post': 'animals/{animalId}/dosages',
  'dosing.destroy': 'animals/{animalId}/dosages/{doseId}',
  'requests.templates.index': 'requests/templates',
  'teams.update': 'teams',
  'projects.list': 'projects',
  'projects.get': 'projects/{projectId}',
  'datatables.export': 'studies/{studyId}/datatables/{dataTableId}/export',
  'snapshot.export': 'studies/{studyApiId}/snapshot/export/{exportSnapshotApiId}',
  'drafts.studies': 'drafts/studies',
  'drafts.studies.get': 'drafts/studies/{id}',
  'drafts.studies.update': 'drafts/studies/{id}',
  'drafts.studies.delete': 'drafts/studies/{id}',
  'drafts.studies.bulkDelete': 'drafts/studies/multiple',
  'util.id': 'util/id',
  'util.db.id': 'util/{entity}/id',
  'v1.credentials.get': 'api/v1/credentials',
  'v1.measurements.get': 'api/v1/animals/{id}/measurements',
  'v1.observations.get': 'api/v1/animals/{id}/observations',
  'v1.samples.get': 'api/v1/animals/{id}/samples',
  'v1.studies.animals.get': 'api/v1/studies/{id}/animals',
  'v1.tasks.get': 'api/v1/tasks',
} as const;

export type EndpointParameters = {
  me: {};
  config: {};
  'sessions.create': {};
  'sessions.get-details': {};
  'global-data': {};
  'config.timezones': {};
  'user.update': {};
  'glossary.show': {};
  'glossary.create': {};
  'team-glossary.list': {};
  'team-glossary.create': {};
  'team-glossary.update': {};
  'team-glossary.destroy': {};
  'team-glossary.show': {
    glossaryId?: Parameter;
  };
  'meta-glossary.show': {};
  'meta-glossary.create': {};
  'meta-glossary.update': {};
  'meta-glossary.destroy': {};
  'meta-glossary.search': {};
  'meta-glossary.used-options': {};
  'team.glossary.treatments': {};
  'team.glossary.treatment.update': {
    id?: Parameter;
  };
  'metadata.show': {
    id?: Parameter;
  };
  'metadata.options.show': {
    id?: Parameter;
  };
  'team.sso_providers': {
    type?: Parameter;
  };
  'team.studies.forms': {};
  'team.studies.forms.get': {
    formId?: Parameter;
  };
  'team.studies.forms.show': {
    id?: Parameter;
  };
  'team.studies.forms.showAll': {};
  'team.studies.forms.bulkDelete': {};
  'team.studies.forms.create': {};
  'team.studies.forms.update': {
    id?: Parameter;
  };
  'team.studies.forms.delete': {
    id?: Parameter;
  };
  'team.studies.forms.metadata': {
    id?: Parameter;
  };
  'team.studies.forms.section.show': {
    formId?: Parameter;
    sectionId?: Parameter;
  };
  'team.studies.forms.section.create': {
    formId?: Parameter;
  };
  'team.studies.forms.section.update': {
    formId?: Parameter;
    sectionId?: Parameter;
  };
  'team.studies.forms.section.delete': {
    formId?: Parameter;
    sectionId?: Parameter;
  };
  'team.studies.groups': {};
  'password_resets.create': {};
  'password_resets.update': {};
  'password_resets.evaluate': {};
  'studies.create': {};
  'studies.search': {};
  'studies.base': {};
  'studies.show.p': {
    id?: Parameter;
  };
  'studies.metrics': {
    id?: Parameter;
  };
  'studies.show': {
    id?: Parameter;
    include?: Parameter;
  };
  'studies.active': {};
  'studies.archived': {};
  'studies.cancelled': {};
  'studies.links': {
    study_id?: Parameter;
  };
  'studies.links.delete': {
    study_id?: Parameter;
    link_id?: Parameter;
  };
  'studies.links.update': {
    study_id?: Parameter;
    link_id?: Parameter;
    include?: Parameter;
  };
  'studies.links.create': {
    study_id?: Parameter;
    include?: Parameter;
  };
  'studies.links.create.bulk': {
    study_id?: Parameter;
    include?: Parameter;
  };
  'studies.samples.index': {
    studyId?: Parameter;
  };
  'study.types': {};
  'study.presets': {};
  'studies.update': {
    id?: Parameter;
  };
  'studies.destroy': {
    id?: Parameter;
  };
  'studies.archive': {
    id?: Parameter;
  };
  'studies.unarchive': {
    id?: Parameter;
  };
  'studies.cancel': {
    id?: Parameter;
  };
  'studies.uncancel': {
    id?: Parameter;
  };
  'studies.groups.metrics.list': {
    studyId?: Parameter;
    query?: Parameter;
  };
  'studies.groups.list': {
    id?: Parameter;
  };
  'studies.alerts.settings.list': {
    studyId?: Parameter;
  };
  'studies.alerts.settings.create': {
    studyId?: Parameter;
  };
  'studies.alerts.settings.update': {
    studyId?: Parameter;
    alertId?: Parameter;
  };
  'studies.animal.alert.update': {
    studyId?: Parameter;
    animalId?: Parameter;
    alertId?: Parameter;
  };
  'studies.alerts.settings.bulk-delete': {
    studyId?: Parameter;
  };
  'studies.groups.configure.treatments': {
    studyId?: Parameter;
  };
  'studies.cages.create': {
    studyId?: Parameter;
  };
  'studies.collections': {};
  'studies.collections.show': {
    studyId?: Parameter;
    id?: Parameter;
  };
  'studies.collections.create': {
    id?: Parameter;
  };
  'studies.collections.animals': {
    studyId?: Parameter;
    id?: Parameter;
  };
  'studies.cages.list': {
    studyId?: Parameter;
  };
  'studies.files': {
    id?: Parameter;
  };
  'studies.files.update': {
    id?: Parameter;
  };
  'studies.files.name': {
    id?: Parameter;
    name?: Parameter;
  };
  'drafts.files': {
    id?: Parameter;
  };
  'drafts.files.name': {
    id?: Parameter;
    name?: Parameter;
  };
  'studies.export.create.email': {
    id?: Parameter;
  };
  'studies.export.create.download': {
    id?: Parameter;
  };
  'studies.export.audit-log': {
    id?: Parameter;
  };
  'studies.measurements.import-template': {
    id?: Parameter;
  };
  'studies.groups.bulk': {
    studyId?: Parameter;
  };
  'studies.measurements.get': {
    id?: Parameter;
  };
  'studies.measurements.create': {
    id?: Parameter;
  };
  'studies.measurements.update': {
    id?: Parameter;
  };
  'studies.observations.check': {
    id?: Parameter;
  };
  'studies.treatments': {
    studyId?: Parameter;
  };
  'studies.treatment': {
    studyId?: Parameter;
    treatmentId?: Parameter;
  };
  'studies.treatment.show': {
    studyId?: Parameter;
    query?: Parameter;
  };
  'studies.treatment.delete': {
    studyId?: Parameter;
  };
  'studies.animal.show': {
    studyId?: Parameter;
    id?: Parameter;
  };
  'studies.animal.alerts': {
    studyId?: Parameter;
    id?: Parameter;
  };
  'animals.update.bulk': {};
  animal: {
    id?: Parameter;
  };
  'animals.identifiers.bulk.update': {};
  'animals.tracking.date.bulk.update': {};
  'animals.dob.bulk.update': {};
  'animals.sex.bulk.update': {};
  'animals.terminate': {};
  'animals.update-terminate': {};
  'animals.destroyMany': {
    study?: Parameter;
  };
  'animals.destroyManyColony': {};
  'animals.undo-terminate': {};
  'animals.dose.create': {
    animalId?: Parameter;
  };
  'animals.update-termination': {};
  'studies.check-measurements': {
    id?: Parameter;
  };
  'studies.observations.show': {
    id?: Parameter;
  };
  'studies.observations.types': {
    id?: Parameter;
  };
  'studies.observations.export': {
    id?: Parameter;
  };
  'studies.observations.filter.get': {
    id?: Parameter;
  };
  'studies.approvals.list': {
    id?: Parameter;
  };
  'studies.requests.list': {
    id?: Parameter;
  };
  'studies.requests.get': {
    studyId?: Parameter;
    requestId?: Parameter;
    query?: Parameter;
  };
  'studies.requests.create': {
    study?: Parameter;
  };
  'studies.requests.update': {
    requestId?: Parameter;
  };
  'studies.randomization.export': {
    studyApiId?: Parameter;
  };
  'requests.templates.list': {};
  'requests.templates.show': {
    requestTemplate?: Parameter;
  };
  'requests.templates.update': {
    requestTemplate?: Parameter;
  };
  'requests.templates.delete': {
    requestTemplate?: Parameter;
  };
  'requests.request.template.show': {
    requestId?: Parameter;
  };
  'requests.request.show': {
    requestId?: Parameter;
  };
  'requests.request.samples': {
    requestId?: Parameter;
    query?: Parameter;
  };
  'requests.request.samples.add': {
    requestId?: Parameter;
  };
  'requests.request.samples.delete.bulk': {
    requestId?: Parameter;
  };
  'requests.comments': {
    requestId?: Parameter;
  };
  'approvals.templates.create': {};
  'approvals.templates.list': {
    query?: Parameter;
  };
  'approvals.templates.list.all': {};
  'approvals.templates.show': {
    approvalTemplate?: Parameter;
  };
  'approvals.templates.update': {
    approvalTemplate?: Parameter;
  };
  'approvals.templates.delete': {
    approvalTemplate?: Parameter;
  };
  'approvals.request.show': {
    approvalRequestId?: Parameter;
  };
  'approvals.requests.update': {
    approvalRequestId?: Parameter;
  };
  'approvals.requests.show.pending': {};
  'approvals.requests.show.approved': {};
  'approvals.requests': {
    approvalRequestId?: Parameter;
    query?: Parameter;
  };
  'approvals.comments': {
    approvalId?: Parameter;
  };
  'approvals.approvers.add': {
    approvalRequestId?: Parameter;
  };
  'user.requests.list': {};
  requests: {
    requestId?: Parameter;
    query?: Parameter;
  };
  'requests.update': {
    requestId?: Parameter;
  };
  'users.list': {};
  'users.create': {};
  'users.update': {
    id?: Parameter;
  };
  'users.invitation': {
    id?: Parameter;
  };
  'users.revoke-invitation': {
    id?: Parameter;
  };
  'users.accept-invite': {
    invitation?: Parameter;
  };
  'collections.update': {
    id?: Parameter;
  };
  'collections.destroy': {
    id?: Parameter;
  };
  'observations.create': {
    id?: Parameter;
  };
  'observations.update': {
    id?: Parameter;
  };
  'observations.destroy': {
    id?: Parameter;
  };
  'animal.sample.create': {
    id?: Parameter;
  };
  'animal.sample.update': {
    id?: Parameter;
  };
  'animal.sample.get': {
    animalId?: Parameter;
    sampleId?: Parameter;
  };
  'animal.latestMeasurement.get': {
    studyId?: Parameter;
    animalId?: Parameter;
    measurement?: Parameter;
  };
  'samples.index': {};
  'samples.update': {
    id?: Parameter;
  };
  'samples.destroy': {
    id?: Parameter;
  };
  'samples.export': {};
  'samples.export.study': {
    studyId?: Parameter;
  };
  'samples.sample-filters': {};
  'samples.validate.isNameUnique': {};
  'samples.bulk.create': {
    studyId?: Parameter;
  };
  'tasks.templateGroups.create': {};
  'tasks.templateGroups.show': {};
  'tasks.templateGroups.show-item': {
    id?: Parameter;
  };
  'tasks.templateGroups.delete': {
    id?: Parameter;
  };
  'tasks.templateGroups.update': {
    id?: Parameter;
  };
  'tasks.template.create': {
    taskTemplateGroup?: Parameter;
  };
  'tasks.template.update': {
    id?: Parameter;
  };
  'tasks.template.destroy': {
    id?: Parameter;
  };
  'tasks.show': {
    date?: Parameter;
  };
  'tasks.update': {
    id?: Parameter;
  };
  'tasks.create': {
    study?: Parameter;
  };
  'tasks.destroy': {
    id?: Parameter;
  };
  'tasks.pending': {};
  'species.index': {
    query?: Parameter;
  };
  species: {};
  'species.update': {};
  'animals.createMany': {};
  'cages.show': {};
  'cages.createMany': {};
  'cages.updateMany': {};
  'cages.destroyMany': {};
  'cages.index': {};
  'cages.destroy': {
    id?: Parameter;
  };
  'cages.update': {
    id?: Parameter;
  };
  'cage.index': {
    id?: Parameter;
    query?: Parameter;
  };
  'animals.updateMany': {};
  'cages.filterOptions': {};
  'animals.filterOptions': {};
  'animals.show': {};
  'animals.search': {};
  'credentials.scopes.get': {};
  'teams.treatmentTypes.get': {
    query?: Parameter;
  };
  'teams.treatmentTypes.post': {};
  'teams.treatmentTypes.validate': {
    treatmentName?: Parameter;
  };
  'teams.treatmentTypes.delete': {
    treatmentTypeId?: Parameter;
  };
  'treatment-units': {};
  'treatment.form': {
    treatmentMethod?: Parameter;
  };
  'dosing.animals.post': {
    animalId?: Parameter;
  };
  'dosing.destroy': {
    animalId?: Parameter;
    doseId?: Parameter;
  };
  'requests.templates.index': {};
  'teams.update': {};
  'projects.list': {};
  'projects.get': {
    projectId?: Parameter;
  };
  'datatables.export': {
    studyId?: Parameter;
    dataTableId?: Parameter;
  };
  'snapshot.export': {
    studyApiId?: Parameter;
    exportSnapshotApiId?: Parameter;
  };
  'drafts.studies': {};
  'drafts.studies.get': {
    id?: Parameter;
  };
  'drafts.studies.update': {
    id?: Parameter;
  };
  'drafts.studies.delete': {
    id?: Parameter;
  };
  'drafts.studies.bulkDelete': {};
  'util.id': {};
  'util.db.id': {
    entity?: Parameter;
  };
  'v1.credentials.get': {};
  'v1.measurements.get': {
    id?: Parameter;
  };
  'v1.observations.get': {
    id?: Parameter;
  };
  'v1.samples.get': {
    id?: Parameter;
  };
  'v1.studies.animals.get': {
    id?: Parameter;
  };
  'v1.tasks.get': {};
};
